import React from 'react';
import { CheckCircleIcon } from '@/assets/ui/activity';

interface CompletionBadgeProps {
  /**
   * Text to display in the badge. Defaults to "Completed"
   */
  text?: string;
  /**
   * Whether to show the check icon
   */
  showIcon?: boolean;
}

/**
 * Reusable badge component for displaying completion status.
 * Used across unit cards, subunit rows, and activity rows.
 */
export default function CompletionBadge({
  text = 'Completed',
  showIcon = true,
}: CompletionBadgeProps) {
  return (
    <div className='bg-success_highlight text-success flex justify-center items-center gap-1 pl-3 pr-2.5 py-1 rounded-[16px]'>
      {showIcon && <CheckCircleIcon className='w-[12px] h-[12px]' />}
      <span className='text-success text-center text-xs not-italic font-medium leading-[18px]'>
        {text}
      </span>
    </div>
  );
}
